<div [hidden]="!show">
    <div [class]="cssClass">
        <div [hidden]="!show" class="spin-div">
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
    </div>
</div>